import { Text } from '@weareconceptstudio/core';

//* Styles
import RatingStyle from './style';

const Star = ({ className }) => (
	<svg
		className={className}
		fill='none'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'>
		<path d='M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z' />
	</svg>
);

const Rating = ({ className, showText = true, rate_count = 3 }) => {
	const stars = Array.from({ length: 5 }, (_, index) => {
		if (rate_count >= index + 1) {
			return '100%';
		} else if (rate_count >= index + 0.5) {
			return '50%';
		} else {
			return '0%';
		}
	});

	return (
		<RatingStyle className={className || ''}>
			<div className='wrapper-starts-text'>
				{rate_count ? (
					<>
						{showText ? <Text className={'p p3 font-montserrat-arm-bold'}>{rate_count}</Text> : null}

						<div className={'flex'}>
							{stars.map((fillLevel, index) => (
								<div
									key={index}
									className={'relative-star'}>
									<Star className={fillLevel === '100%' ? 'color-main' : 'back-color'} />

									{fillLevel === '50%' && (
										<div className={'absolute-star'}>
											<Star className={'color-main'} />
										</div>
									)}
								</div>
							))}
						</div>
					</>
				) : null}
			</div>
		</RatingStyle>
	);
};

export default Rating;
